<template>
  <div>
    <div class="step-single upcoming" v-show="step.upcoming">
      <div class="step-title">{{ T__("Event type details") }}</div>
    </div>
    <div
      class="step-single form active"
      v-show="step.form"
      :id="'service_form_step' + step.id"
    >
      <div class="step-title">{{ T__("Event Type Details") }}</div>
      <div class="form" @submit.prevent>
        <form-row :validator="$v.form.name">
          <label for="form_name">
            {{ T__("Event type name") }}
            <abbr class="required" title="required">*</abbr>
            <em>{{ T__("required") }}</em>
          </label>
          <span class="txt-help">
            {{
              T__(
                "The event type name will be visible to your invitees. Enter something that will guide them through the booking process. Eg. Consultation call with John."
              )
            }}
          </span>
          <input
            id="form_name"
            type="text"
            v-model="form.name"
            @blur="$v.form.name.$touch()"
            ref="service_name"
          />
        </form-row>

        <form-row :validator="$v.form.is_manage_private">
          <label>
            {{ T__("Privately-managed event type") }}
            <a
              href="https://help.wpcal.io/en/article/what-is-a-privately-managed-event-type-how-to-use-it-724zbj/?utm_source=wpcal_plugin&utm_medium=contextual"
              target="_blank"
              class="icon-q-mark"
            ></a>
          </label>

          <span class="txt-help">
            {{
              T__(
                "Only you will be able to view and manage this event type and its bookings. It will be not be visible to other admins."
              )
            }}
          </span>
          <div
            class="private-et-slider-cont"
            style="margin-bottom:5px;"
            :class="{
              private_event_disabled: is_disable_manage_private
            }"
          >
            {{ T__("Will this event type be privately managed?") }}
            <span
              @click="may_show_manage_private_not_changeable_error"
              style="margin-left:auto;"
            >
              <OnOffSlider
                :name="'service_private'"
                v-model="form.is_manage_private"
                true_value="1"
                false_value="0"
                style="margin-left:auto;"
                :disabled="is_disable_manage_private"
            /></span>
          </div>
          <div v-if="!is_current_admin_is_host">
            {{
              T__(
                "You cannot set another admin's event type as privately managed."
              )
            }}
          </div>
        </form-row>

        <form-row :validator="$v.form.service_admin_user_ids">
          <label>
            {{ T__("Host") }}
            <abbr class="required" title="required">*</abbr>
            <em>{{ T__("required") }}</em>
          </label>
          <span class="txt-help">
            {{
              T__(
                "This event type will be assigned to the admin you select below. The same admin's profile will be used while displaying the event type."
              )
            }}
          </span>
          <div
            class="et-create-host-selector"
            style="margin-bottom:5px;"
            @click="may_show_host_selector_not_changeable_error"
          >
            <HostSelector1ToN
              v-model="form.service_admin_user_ids"
              :max_host="1"
              :disabled="is_disable_host_selector"
            />
          </div>
          <div v-if="is_disable_host_selector">
            {{
              T__(
                "You cannot change the host for your privately managed event types."
              )
            }}
          </div>
          <div style="margin-top: 5px;">
            <router-link to="/settings/admins"
              >Add new host to WPCal</router-link
            >
          </div>
        </form-row>

        <div class="wpc-form-row" v-if="view == 'add'">
          <label for="form_unique_link" style="cursor:default;">
            {{ T__("Event type booking page") }}
          </label>
          <span class="txt-help">
            {{
              T__(
                "A page will be created and the booking widget will be added to it. You can manage it after creating this event type."
              )
            }}
          </span>
        </div>

        <!-- <form-row :validator="$v.form.locations">
          <label for="form_locations">
            Location
            <em>optional</em>
          </label>
          <input id="form_locations" type="text" v-model="form.locations" />
          <template v-slot:after>
            <span class="txt-help">
              Use this to specify how and where both parties will connect at the
              scheduled time. This will be displayed in the booking screen.
            </span>
          </template>
        </form-row> -->
        <form-row>
          <label>
            {{ T__("Location (online &amp; offline)") }}
            <a
              href="https://help.wpcal.io/en/article/how-to-setup-meeting-locations-online-offline-for-event-types-7b10qh/?utm_source=wpcal_plugin&utm_medium=contextual"
              target="_blank"
              class="icon-q-mark"
            ></a>
            <em>{{ T__("optional") }}</em>
          </label>
          <span class="txt-help">
            {{
              T__(
                "Use this to specify how and where both parties will connect at the scheduled time. This will be displayed in the booking screen."
              )
            }}
          </span>
          <AdminLocationSelector v-model="form.locations" :form="form" />
        </form-row>
        <form-row :validator="$v.form.descr">
          <label for="form_descr">
            {{ T__("Description/Instructions") }}
            <em>{{ T__("optional") }}</em>
          </label>
          <span class="txt-help">
            {{
              T__(
                "Use this to provide a short description of your event. This will be displayed in the booking screen."
              )
            }}
          </span>
          <textarea id="form_descr" v-model="form.descr"></textarea>
        </form-row>
        <!-- <div class="wpc-form-row">
          <label for="form_unique_link">
            Event type booking page
            <abbr class="required" title="required">*</abbr>
            <em>required</em>
          </label>
          <input
            id="form_unique_link"
            type="text"
            value="yourwebsite.com/consultation"
          />
          <span class="txt-help">
            This page will be created and the booking widget will be displayed
            here.
          </span>
        </div> -->
        <form-row :validator="$v.form.color">
          <label>
            {{ T__("Event type color") }}
            <em>{{ T__("required") }}</em>
          </label>
          <ColorSelector :form="form" color_prop="color" />
        </form-row>

        <!-- {{ $v.step2 }} -->
        <div class="wpc-form-row">
          <button
            v-if="view == 'add'"
            type="button"
            class="wpc-btn primary lg"
            @click="$emit('validate-may-navigate-or-submit', 2)"
          >
            {{ T__("Continue") }}
          </button>
          <button
            v-else-if="view == 'edit'"
            type="button"
            class="wpc-btn primary lg"
            :disabled="!create_or_update_btn_is_enabled"
            @click="$emit('submit-form', 2)"
          >
            {{ T__("Save") }}
          </button>
          <button
            v-if="view == 'edit'"
            type="button"
            @click="$emit('edit-view-toggle-steps')"
            class="wpc-btn tert-link sm mt10 center"
          >
            {{ T__("Cancel") }}
          </button>
        </div>
      </div>
    </div>
    <div class="step-single summary" v-show="step.summary">
      <div class="step-title">
        <span>{{ T__("Event type details") }}</span>
        <a @click="$emit('set-active-step-and-toggle', 2)">{{ T__("EDIT") }}</a>
      </div>
      <div class="step-summary-content">
        <div>{{ form.name }}</div>
        <div v-if="form.locations.length">
          <span
            style="display: flex;"
            :inner-html.prop="form.locations | locations_summary"
          ></span>
        </div>
      </div>
    </div>
    <!-- <v-dialog /> -->
  </div>
</template>

<script>
import ColorSelector from "@/components/form_elements/ColorSelector.vue";
import AdminLocationSelector from "@/components/form_elements/AdminLocationSelector.vue";
import HostSelector1ToN from "@/components/form_elements/HostSelector1ToN.vue";
import OnOffSlider from "@/components/form_elements/OnOffSlider.vue";

import { isEqual as _isEqual } from "lodash-es";

export default {
  name: "ServiceFormStep2",
  components: {
    ColorSelector,
    AdminLocationSelector,
    HostSelector1ToN,
    OnOffSlider
  },
  props: {
    view: {
      type: String
    },
    step: {
      type: Object,
      required: true
    },
    form: {
      type: Object,
      required: true
    },
    saved_form: {
      type: Object
    },
    create_or_update_btn_is_enabled: {},
    $v: {}
  },
  data() {
    return {};
  },
  computed: {
    is_disable_manage_private() {
      return (
        this.form.is_manage_private == "0" && !this.is_current_admin_is_host
      );
    },
    is_current_admin_is_host() {
      return (
        this.form.service_admin_user_ids.indexOf(
          this.$store.getters.get_current_admin_details.id
        ) != -1
      );
    },
    is_disable_host_selector() {
      return this.is_current_admin_is_host && this.form.is_manage_private == 1;
    }
  },
  methods: {
    auto_focus_form_element() {
      if (this.view == "add" && !this.form.name && this.$refs.service_name) {
        setTimeout(() => {
          this.$refs.service_name.focus();
        }, 50);
      }
    },
    may_show_host_selector_not_changeable_error() {
      if (!this.is_disable_host_selector) {
        return;
      }
      this.$modal.show("dialog", {
        title: this.T__("Heads up!"),
        text: this.T__(
          "You cannot change the host for your privately managed event types."
        ),
        buttons: [
          {
            title: this.T__("Okay"),
            default: true // Will be triggered by default if 'Enter' pressed.
          }
        ]
      });
    },
    may_show_manage_private_not_changeable_error() {
      if (!this.is_disable_manage_private) {
        return;
      }
      this.$modal.show("dialog", {
        title: this.T__("Heads up!"),
        text: this.T__(
          "You cannot set another admin's event type as privately managed."
        ),
        buttons: [
          {
            title: this.T__("Okay"),
            default: true // Will be triggered by default if 'Enter' pressed.
          }
        ]
      });
    },
    may_show_on_change_host_selector_info() {
      console.log("may_show_on_change_host_selector_info");
      if (
        this.view != "edit" ||
        _isEqual(
          this.saved_form.service_admin_user_ids,
          this.form.service_admin_user_ids
        )
      ) {
        return;
      }
      let dialog_descr =
        "<ul class='bull'><li>" +
        this.T__("Existing bookings will NOT be affected.") +
        "</li><li>" +
        this.T__(
          "For existing bookings, the host will not be changed. So, the old host's email, calendar apps and meeting apps will be used."
        ) +
        "</li><li>" +
        this.T__(
          "New and rescheduled bookings will be assigned to the new host. So, emails related to it will be sent to the new host. Also, the new host's email, calendar apps and meeting apps will be used."
        ) +
        "</li></ul>";

      this.$modal.show("dialog", {
        title: this.T__("Change the host?"),
        text: this.Tsprintf(
          this.T__("Here's what will happen -" + dialog_descr)
        ),
        buttons: [
          {
            title: this.T__("Yes, change the host.")
          },
          {
            title: this.T__("No, don't."),
            handler: () => {
              this.form.service_admin_user_ids = this.clone_deep(
                this.saved_form.service_admin_user_ids
              );
              this.$modal.hide("dialog");
            }
          }
        ]
      });
    }
  },
  watch: {
    "step.form": function(new_value) {
      if (new_value) {
        this.auto_focus_form_element();
      }
    },
    "form.service_admin_user_ids": function() {
      this.may_show_on_change_host_selector_info();
    }
  },
  mounted() {
    if (this.view == "add") {
      this.$props.step.summary = true;
    }
  }
};
</script>
<style>
label.slider-label {
  padding: 0 !important;
}
label[for="slider_service_private"] .slider-inner:before {
  content: "YES";
  padding-left: 5px;
}
label[for="slider_service_private"] .slider-inner:after {
  content: "NO";
  padding-right: 7px;
}
.private_event_disabled {
  opacity: 0.7;
}
.et-create-host-selector .ttf-cont .ttf-v-selector .vs__dropdown-toggle {
  padding-left: 6px;
}
.et-create-host-selector .ttf-cont .ttf-v-selector.vs--open {
  margin-bottom: 24px;
}
.et-create-host-selector .ttf-v-selector.vs--open::after {
  top: 13px;
}
</style>
<style scoped>
.private-et-slider-cont {
  display: flex;
  align-items: center;
  border: 1px solid #b1b6d1;
  background-color: #fff;
  padding: 10px 10px 10px 30px;
  border-radius: 5px;
  position: relative;
}
.private-et-slider-cont::before {
  content: "";
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 61.25 78.75'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23131336;%7D%3C/style%3E%3C/defs%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='Layer_1-2' data-name='Layer 1'%3E%3Cpath class='cls-1' d='M56.88,26.25H52.5V21.88a21.88,21.88,0,1,0-43.75,0v4.37H4.38A4.38,4.38,0,0,0,0,30.62V74.38a4.38,4.38,0,0,0,4.38,4.37h52.5a4.37,4.37,0,0,0,4.37-4.37V30.62A4.37,4.37,0,0,0,56.88,26.25ZM17.5,21.88a13.13,13.13,0,1,1,26.25,0v4.37H17.5ZM52.5,70H8.75V35H52.5Z'/%3E%3Cpath class='cls-1' d='M30.62,46.11a6.56,6.56,0,1,0,6.57,6.56A6.57,6.57,0,0,0,30.62,46.11Zm0,8.75a2.19,2.19,0,1,1,2.19-2.19A2.19,2.19,0,0,1,30.62,54.86Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  position: absolute;
  width: 10px;
  height: 13px;
  left: 12px;
  top: 11px;
}
</style>
